export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["COMMA"] = 188] = "COMMA";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["DOWN"] = 40] = "DOWN";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["ESCAPE"] = 27] = "ESCAPE";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["LEFT"] = 37] = "LEFT";
    KeyCode[KeyCode["NUMPAD_ADD"] = 107] = "NUMPAD_ADD";
    KeyCode[KeyCode["NUMPAD_DECIMAL"] = 110] = "NUMPAD_DECIMAL";
    KeyCode[KeyCode["NUMPAD_DIVIDE"] = 111] = "NUMPAD_DIVIDE";
    KeyCode[KeyCode["NUMPAD_ENTER"] = 108] = "NUMPAD_ENTER";
    KeyCode[KeyCode["NUMPAD_MULTIPLY"] = 106] = "NUMPAD_MULTIPLY";
    KeyCode[KeyCode["NUMPAD_SUBTRACT"] = 109] = "NUMPAD_SUBTRACT";
    KeyCode[KeyCode["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KeyCode[KeyCode["PAGE_UP"] = 33] = "PAGE_UP";
    KeyCode[KeyCode["PERIOD"] = 190] = "PERIOD";
    KeyCode[KeyCode["RIGHT"] = 39] = "RIGHT";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["UP"] = 38] = "UP";
})(KeyCode || (KeyCode = {}));
//# sourceMappingURL=enum.js.map